module.exports = __webpack_public_path__ + "media/images/flags/GA-e0746f57141149e4bce0d863c5b54f34.svg";